import { render, staticRenderFns } from "./HKLTabs.vue?vue&type=template&id=419659ad&scoped=true&"
import script from "./HKLTabs.vue?vue&type=script&lang=js&"
export * from "./HKLTabs.vue?vue&type=script&lang=js&"
import style0 from "./HKLTabs.vue?vue&type=style&index=0&id=419659ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419659ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('419659ad')) {
      api.createRecord('419659ad', component.options)
    } else {
      api.reload('419659ad', component.options)
    }
    module.hot.accept("./HKLTabs.vue?vue&type=template&id=419659ad&scoped=true&", function () {
      api.rerender('419659ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/Tab/HKLTabs.vue"
export default component.exports